import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero'; 
import Benefits from '../components/Benefits'; 
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import ImpactAndTestimonials from '../components/ImpactandTestimonials';

function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Benefits />
    <ImpactAndTestimonials/>
      <Contact />
      <Footer />
    </div>
  );
}

export default Home;